import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import envConfig from "../../lib/config"
import moment from 'moment';
import { getpurchasetokenlist } from '../../actions/users';
import axios from 'axios';
import Exportexcel from "../pdf/Excelexport"
import Exportpdf from "../pdf/Exportpdf"
import Exportcsv from "../pdf/Exportcsv"

const PurchaseList = () => {
    const [userdet, setUser] = useState([]);
    const[exportdata,setExportdata]=useState([])

    useEffect(() => {
        getTokenlist();
    }, [])

    const getTokenlist = async () => {
        var test = await getpurchasetokenlist();
        if(test.Success){
          setUser(test.userValue);
    
          var ddd= test.userValue.map(({_id,__v,createdAt,...rest})=>{
           
            return rest
         })
        setExportdata(ddd)
        }
        else
          toastAlert("success", "Error on Server")
    }

    const columns = [
        {
          key: "ind",
          text: "SNO",
          className: "name",
          align: "center",
          sortable: true,
          cell:(row, index, column, id)=>
          <p className='text-center exchange_table_values'>{index+1}</p>
      
        },
        {
          key: "action",
          text: "Mode of Transaction",
          className: "tokenOwner",
          align: "center",
          sortable: false,
          cell:val=>
          <div className='text-center exchange_table_values'>
          {
            val.action === "BuySell"?
            <p>{val.action}</p>
            :
            <p>{val.ifBid}</p>
          }
          </div>
        },
        {
      
          key: "tokenID",
          text: "Token ID",
          className: "tokenId",
          align: "center",
          sortable: false,
          cell:(val)=>
            <p className='text-center exchange_table_values'>{val.tokenID}</p>
        },
        {
          key: "tokenName",
          text: "Token Name",
          className: "Name",
          align: "center",
          sortable: false,
          cell:(val)=>
            <p className='text-center exchange_table_values'>{val.tokenName}</p>
        },
       {
          key: "from",
          text: "Old Token Owner",
          className: "tokenOwner",
          align: "center",
          sortable: false,
          cell:val=>
            <p className='text-center exchange_table_values'>{val.to}</p>
        },
        {
          key: "to",
          text: "New Token Owner",
          className: "tokenOwner",
          align: "center",
          sortable: false,
          cell:val=>
            <p className='text-center exchange_table_values'>{val.from}</p>
        },
      
        {
          key: "NoofNFT",
          text: "No of NFT Transacted",
          className: "balance",
          align: "center",
          sortable: false,
          cell:val=>
          <div className='text-center exchange_table_values'>{(val.NoofNFT)}</div>
      
      
        },
    
        {
          key: "tokenPrice",
          text: "Transaction Amount",
          className: "tokenPrice",
          align: "center",
          sortable: false,
          cell:val=>
          <div className='text-center exchange_table_values'><>{(val.tokenPrice)!=undefined?String(val.tokenPrice):'Sold Price currently not available'}</> <>{val.tokenPrice>0?String(val.istoken):''}</></div>
        },
       
        {
      
          key: "action",
          text: "Token Status",
          className: "status",
          align: "center",
          sortable: false,
          cell:val=>
          <div className='text-center exchange_table_values'>{String(val.action)}</div>
      
        },
      
        {
          key: "created",
          text: "Date of Sale",
          className: "Date",
          align: "center",
          sortable: false,
          cell: record =>
            <div className='text-center exchange_table_values'><p>{moment(record.created).format('MMMM,Do YYYY, hh:mm A')}</p></div>
        },
        
      ];
    
    const config = {
      page_size: 5,
      length_menu: [10, 20, 50],
      filename: "Users",
      no_data_text: "No user found!",
  
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: <> Previous </>,
          next: <>Next</>,
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
      defaultSortAsc: true,
  };

  return (
    <>
          <Container fluid className="common_bg position-relative">
            <div className="liner"></div>
            <Row>
              <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                <Sidebar />
              </Col>
              <Col  xl={10} lg={12}>
                <Header title={'Sales Report'}/>
    
                <div className="common_page_scroller mt-5 pe-2">
                <div className="page_header">
            <h2>Sales Report List</h2>
          </div>
                  <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                    <ReactDatatable
                      config={config}
                      records={userdet}
                      columns={columns}
                    />
                  </div>
                </div>
                <div className='bottom_btn_comp'>
        <Exportexcel excelData={exportdata} fileName={'purchase'} />
        <Exportpdf pdfData={exportdata} fileName={'purchase'} />
        <Exportcsv csvData={exportdata} fileName={'purchase'} />
      </div>
              </Col>
            </Row>
          </Container>
        </>
  )
}

export default PurchaseList